<template>
    <div>
        <div>
            <div class="greybox">
                <h1 class="formheader">{{stageTitle}}</h1>
                <p>We have received your claim details and it is currently being reviewed.</p>

                <p>Your claim reference number is: <strong>{{claimReference}}</strong></p>
                <p>You can check on the status of your claim by clicking <strong>Check status of a claim</strong> above and logging in using the details we have sent to you via email.</p>
                <p>You can also contact the claims team on  {{resellerInfo.telephone}} during office hours</p>
                <button class="button mt-3" @click="handleCancelClick('claims')">My Claims</button>
            </div>
        </div>
    </div>
</template>

<script>

import tigaClaimForm from '@/mixins/tigaClaimForm'
import doc from '@/components/Upload.vue'

export default {
  name: 'thankyou',
  mixins: [
    tigaClaimForm
  ],
  components: {
    doc
  },
  data () {
    return {
      resellerInfo: require('../../assets/theme/' + process.env.VUE_APP_RESELLER_ID + '/reseller.json'),
      entityType: 1000,
      documents: []
    }
  },
  beforeMount () {
    let { submissionResponse } = this.$store.state.claimform
    if (submissionResponse) {
      let { incidentType } = submissionResponse
      if (incidentType) {
        this.fetchDocumentTypes(incidentType.id)
      }
    }
  },
  mounted () {

  },
  beforeRouteLeave (to, from, next) {
    // overwrite method in mixin because we don't want to save the form as it's been submitted!
    next()
  },
  computed: {
    claimReference () {
      if (this.$store.state.claimform.submissionResponse) {
        return this.$store.state.claimform.submissionResponse.claimReference
      }

      return ''
    },
    formRef () {
      if (this.$store.state.claimform.submissionResponse) {
        return this.$store.state.claimform.submissionResponse.claimId
      }

      return ''
    },
    incidentTypeId () {
      if (this.$store.state.claimform.submissionResponse) {
        return this.$store.state.claimform.submissionResponse.incidentType.Id
      }

      return 0
    },
    stageTitle() {
      return this.$textManager.getText("title", this.$route.name)
    }
  },
  methods: {
    handleCancelClick (url) {
      if (url === 'claims') {
        this.$router.push({ path: '/myclaims/list' })
          .catch(e =>  { /* DO NOTHING */ })
      } else if (url === 'docs') {
        this.$router.push({ path: '/myclaims/supportingdocs' })
          .catch(e => { /* DO NOTHING */ })
      }
      
    }
  }
}
</script>

<style scoped>
</style>
